import CustomerBaseController from '../common/customer.base.controller'
import AppConstants from "../../../../../config/app.constants";
class CustomerEditController extends CustomerBaseController {
	/*@ngInject*/
	constructor(Auth, $state, User, CustomerService, Modal, $translate, $stateParams, ContractService, $q, CommonLayoutService, ContractTypeService, BillableEventsService) {
		// _= billing
		super(Auth, $state, User, CustomerService, Modal, $translate, $stateParams)
		this.CustomerService = CustomerService
		this.ContractService = ContractService
		this.CommonLayoutService = CommonLayoutService;
		this.ContractTypeService = ContractTypeService;
		this.BillableEventsService = BillableEventsService;
		this.$q = $q
		this.model = {
			id: '',
			name: '',
			accountingId: '',
			status: false,
			_address: '',
			_address2: '',
			_city: '',
			_state: '',
			_zip: '',
			_POC: '',
			_phone: '',
			_email: '',
			effectiveDate: new Date(),
			expirationDate: null,
			today: moment().hour(0).minutes(0).second(0).toDate(),
			billingStatus: false,
			servicePriority: false,
			onDemandPickup: false,
			orderCutoff: false,
			orderCutoffDays: null,
			orderCutoffTime: null,
			serviceEmail: '',
			billToContractTransportId: null,
			billToContractDepositId: null,
			billToContractChangeOrderId: null,
			billToContractATMServiceId: null,
			billToContractCashHandlingId: null,
			billToContractMaintenanceId: null,
			sameForAll: false,
			billToContractTransportStatus: true,
			billToContractDepositStatus: true,
			billToContractChangeOrderStatus: true,
			billToContractATMServiceStatus: true,
			billToContractCashHandlingStatus: true,
			billToContractMaintenanceStatus: true,
			annualIncrease: null,
			contractPocName: '',
			contractPocEmail:'',
			contractAddress:'',
			contractCity:'',
			contractState:null,
			contractZip:'',
			contractPocPhone:'',
			contractTypeObj: {
				totalRecords: 0,
				results: [],
				loading: false
			},
			contractPaymentMethod:'',
			contractType:'',
			surcharges: this.buildDefaultSurcharges()
		}

		this.pageName = "customer"

		this.toggleSwitchUI = {
			size: 'small',
			label: {
				on: this.$translate.instant('common.yes'),
				off: this.$translate.instant('common.no'),
			},
			onColor: 'success',
			offColor: 'danger'
		}

		this.serviceSchedule = [{
			label: this.$translate.instant('location.mon'),
			model: 'serviceScheduleMon'
		},
		{
			label: this.$translate.instant('location.tues'),
			model: 'serviceScheduleTue'
		},
		{
			label: this.$translate.instant('location.wed'),
			model: 'serviceScheduleWed'
		},
		{
			label: this.$translate.instant('location.thurs'),
			model: 'serviceScheduleThu'
		},
		{
			label: this.$translate.instant('location.fri'),
			model: 'serviceScheduleFri'
		},
		{
			label: this.$translate.instant('location.sat'),
			model: 'serviceScheduleSat'
		},
		{
			label: this.$translate.instant('location.sun'),
			model: 'serviceScheduleSun'
		},
		{
			label: this.$translate.instant('location.hol'),
			model: 'serviceScheduleHol'
		}]

		this.states = [
			"Alabama", "Alaska", "American Samoa", "Arizona", "Arkansas", "California", "Colorado",
			"Connecticut", "Delaware", "District Of Columbia", "Federated States Of Micronesia",
			"Florida", "Georgia", "Guam", "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa",
			"Kansas", "Kentucky", "Louisiana", "Maine", "Marshall Islands", "Maryland", "Massachusetts",
			"Michigan", "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada",
			"New Hampshire", "New Jersey", "New Mexico", "New York", "North Carolina", "North Dakota",
			"Northern Mariana Islands", "Ohio", "Oklahoma", "Oregon", "Palau", "Pennsylvania", "Puerto Rico",
			"Rhode Island", "South Carolina", "South Dakota", "Tennessee", "Texas", "Utah", "Vermont",
			"Virgin Islands", "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming"
		];

		this.branchId = this.User.getUser().branchId;
		this.languageId = this.User.getUser().languageId;
		this.loggedInUser = this.User.getUser().id;
		this.paymentMethodList = CommonLayoutService.paymentMethod();
		this.billingCategoryObj = {};

		this.contractMap = {
			'billToContractTransportId': 'Transport',
			'billToContractDepositId': 'Deposit',
			'billToContractChangeOrderId': 'ChangeOrder',
			'billToContractATMServiceId': 'ATMService',
			'billToContractCashHandlingId': 'CashHandling',
			'billToContractMaintenanceId': 'Maintenance'
		}

		this.contractIdKeyObj = {
			transport: 'Transport',
			deposit: 'Deposit',
			changeOrder: 'ChangeOrder',
			ATMService: 'ATMService',
			cashHandling: 'CashHandling',
			maintenance: 'Maintenance'
		}
	}

	isDisabledDate = function (currentDate, mode) {
		if (this.model.expirationDate !== null) {
			if (this.model.effectiveDate > this.model.expirationDate) {
				this.model.expirationDate = this.model.effectiveDate
			}
			else if (this.model.effectiveDate == null) {
				this.model.expirationDate = null
			}
		}
		this.effectiveMinDate = {
			minDate: this.model.effectiveDate
		}
	}

	$onInit() {
		this.$q.all([
			this.ContractService.all(null, 0, AppConstants.defaultPageLimit),
			this.Service.get(this.$stateParams.id),
			this.getContractType('', 0),
			this.getBillingEventOptions()
		])
			.then((data) => {
				this.rawId = data[1].id;
				this.model.id = data[1].id;
				this.model.name = data[1].name;
				this.model.accountingId = data[1].accountingId;
				this.model.contact = data[1].contact;
				this.model.customerContracts = data[1].customerContracts || [];
				this.model.status = !!data[1].isEnabled;
				this.model._address = data[1].billingAddress;
				this.model._address2 = data[1].billingAddress2;
				this.model._state = data[1].billingState;
				this.model._city = data[1].billingCity;
				this.model._zip = data[1].billingZip;
				this.model._phone = data[1].billingPhone;
				this.model._email = data[1].billingEmail;
				this.model._POC = data[1].billingPOC;
				this.model.billingStatus = data[1].billingStatus;
				this.model.servicePriority = data[1].servicePriority;
				this.model.onDemandPickup = data[1].onDemandPickup;
				this.model.orderCutoff = data[1].orderCutoff;
				this.model.orderCutoffDays = data[1].orderCutoffDays;
				this.model.orderCutoffTime = data[1].orderCutoffTime ? moment(data[1].orderCutoffTime, 'HH:mm:ss').toDate() : null;
				this.model.serviceEmail = data[1].serviceEmail;
				this.model.billToContractTransportId = this.mappingContractRecord(data[1].billToContractTransport);
				this.model.billToContractDepositId = this.mappingContractRecord(data[1].billToContractDeposit);
				this.model.billToContractChangeOrderId = this.mappingContractRecord(data[1].billToContractChangeOrder);
				this.model.billToContractATMServiceId = this.mappingContractRecord(data[1].billToContractATMService);
				this.model.billToContractCashHandlingId = this.mappingContractRecord(data[1].billToContractCashHandling);
				this.model.billToContractMaintenanceId = this.mappingContractRecord(data[1].billToContractMaintenance);
				this.model.serviceScheduleMon = data[1].serviceScheduleMon;
				this.model.serviceScheduleTue = data[1].serviceScheduleTue;
				this.model.serviceScheduleWed = data[1].serviceScheduleWed;
				this.model.serviceScheduleThu = data[1].serviceScheduleThu;
				this.model.serviceScheduleFri = data[1].serviceScheduleFri;
				this.model.serviceScheduleSat = data[1].serviceScheduleSat;
				this.model.serviceScheduleSun = data[1].serviceScheduleSun;
				this.model.serviceScheduleHol = data[1].serviceScheduleHol;
				this.model.effectiveDate = data[1].effectiveDate ? new Date(data[1].effectiveDate) : null;
				this.model.expirationDate = data[1].expirationDate ? new Date(data[1].expirationDate) : null;
				this.model.totalContractDocuments = data[1].totalContractDocuments;
				this.contracts = this.mappingContractDatas(data[0].results);
				this.totalContract = data[0].total;
				this.model.annualIncrease = data[1].annualIncrease ? data[1].annualIncrease + '%' :  null;
				this.model.customerContractId = data[1].customerContractId ? data[1].customerContractId: null
				this.model.contractPocName = data[1].customerContractData ? data[1].customerContractData.POCName: null;
				this.model.contractPocEmail = data[1].customerContractData ? data[1].customerContractData.POCEmail: null;
				this.model.contractPocPhone = data[1].customerContractData ? data[1].customerContractData.POCPhone: null;
				this.model.contractAddress = data[1].customerContractData ? data[1].customerContractData.address: null;
				this.model.contractCity = data[1].customerContractData ? data[1].customerContractData.city: null;
				this.model.contractState = data[1].customerContractData ? data[1].customerContractData.state: null;
				this.model.contractZip = data[1].customerContractData ? data[1].customerContractData.zip: null;
				this.model.contractPaymentMethod = data[1].customerContractData ? data[1].customerContractData.paymentMethod: null;
				this.model.contractType = data[1].contractType ? data[1].contractType: null;

				this.applySurchargeOptions(this.model.surcharges, data[3]);
				this.applySurchargeData(this.model.surcharges, data[1]);

				this.todayMinDate = {
					minDate: this.model.today
				}

				this.effectiveMinDate = {
					minDate: this.model.effectiveDate
				}
			})
			.then(() => {
				const list = [];
				this.contractIds = Object.keys(this.contractMap);

				this.contractIds.forEach((id) => {
					if (this.model[id]) {
						list.push({
							type: this.contractMap[id],
							contractId: this.model[id].value
						})
						this.billingCategoryObj[`billToContract${this.contractMap[id]}Id`] = { process: true };
					}
				})
		
				this.Service.getBillingRulesInfo(this.languageId, list)
					.then((data) => {
						this.contractIds.forEach((id) => {
							if (this.model[id]) {
								this.billingCategoryObj[`billToContract${this.contractMap[id]}Id`].details = data[this.contractMap[id]];
							}
						})
					})
					.catch((err) => {
						console.log(err);
					})
					.finally(() => {
						this.contractIds.forEach((id) => {
							if (this.model[id]) {
								this.billingCategoryObj[`billToContract${this.contractMap[id]}Id`].process = false;
							}
						})
					})
			})
			.catch((err) => {
				this.error = err.message;
			})
			.finally(() => {
				this.loading = false;
			});
	}

	mappingContractRecord(contract) {
		if (contract == null) return contract;

		contract.value = contract.id;
		contract.title = contract.id;
		contract.names = contract.contractName;
		contract.Key = contract.id + ' | ' + contract.contractName;
		contract.Value = contract.id;
		return contract;
	}

	delete(index) {
		let contract = this.model.customerContracts[index]
		this.confirmDelete(contract, index)
	}

	confirmDelete(contract, index) {
		this.Modal.confirm({
			header: this.$translate.instant(this.id + '.delete_title'),
			message: this.$translate.instant(this.id + '.delete_message'),
			callback: ({
				modal
			}) => {
				if (contract.isNew) {
					this.model.customerContracts.splice(index, 1)
				} else {
					this.ContractService.remove(contract.id)
						.then(() => {
							this.model.customerContracts.splice(index, 1)
						})
				}
				modal.close()
			},
			negative: ({
				modal
			}) => {
				modal.close()
			},
			type: 'primary',
			buttons: ['common.yes', 'common.no']
		})
	}

	reset() {
		this.$onInit();
		// this.Service.get(this.$stateParams.id)
		// 	.then((data) =>{
		// 		this.$onInit();
		// 	})
	}

	toggleDay(day) {
		this.model[day.model] = !this.model[day.model]
	}

	isDaySelected(day) {
		return this.model[day.model];
	}

	submit(evt) {
		if (!this.validate()) {
			return
		}
		this.loading = true;

		const { customerFields, surchargeBillingEvents } = this.mapSurchargesForSubmit(this.model.surcharges);

		this.Service.update(this.rawId, {
			id: this.rawId,
			...customerFields,
			name: this.model.name,
			contact: this.model.contact,
			accountingId: this.model.accountingId,
			isEnabled: this.model.status,
			billingAddress: this.model._address,
			billingAddress2: this.model._address2,
			billingState: this.model._state,
			billingCity: this.model._city,
			billingZip: this.model._zip,
			billingPhone: this.model._phone,
			billingEmail: this.model._email,
			billingPOC: this.model._POC,
			billingStatus: this.model.billingStatus,
			servicePriority: this.model.servicePriority,
			onDemandPickup: this.model.onDemandPickup,
			orderCutoff: this.model.orderCutoff,
			orderCutoffDays: this.model.orderCutoff && this.model.orderCutoffDays !== null && this.model.orderCutoffDays !== ''
				? parseInt(this.model.orderCutoffDays, 10) : null,
			orderCutoffTime: this.model.orderCutoff && this.model.orderCutoffTime
				? moment(this.model.orderCutoffTime).format('HH:mm:ss') : null,
			serviceEmail: this.model.serviceEmail,
			effectiveDate: this.model.effectiveDate ? this.model.effectiveDate : null,
			expirationDate: this.model.expirationDate ? this.model.expirationDate : null,
			serviceScheduleMon: this.model.serviceScheduleMon,
			serviceScheduleTue: this.model.serviceScheduleTue,
			serviceScheduleWed: this.model.serviceScheduleWed,
			serviceScheduleThu: this.model.serviceScheduleThu,
			serviceScheduleFri: this.model.serviceScheduleFri,
			serviceScheduleSat: this.model.serviceScheduleSat,
			serviceScheduleSun: this.model.serviceScheduleSun,
			serviceScheduleHol: this.model.serviceScheduleHol,
			billToContractTransportId: this.model.billToContractTransportId ? this.model.billToContractTransportId.value : null,
			billToContractDepositId: this.model.billToContractDepositId ? this.model.billToContractDepositId.value : null,
			billToContractChangeOrderId: this.model.billToContractChangeOrderId ? this.model.billToContractChangeOrderId.value : null,
			billToContractATMServiceId: this.model.billToContractATMServiceId ? this.model.billToContractATMServiceId.value : null,
			billToContractCashHandlingId: this.model.billToContractCashHandlingId ? this.model.billToContractCashHandlingId.value : null,
			billToContractMaintenanceId: this.model.billToContractMaintenanceId ? this.model.billToContractMaintenanceId.value : null,
			annualIncrease:  this.model.annualIncrease ? this.convertStr(this.model.annualIncrease) : null,
			customerContractId: this.model.customerContractId,
			contractTypeId: this.model.contractType,
			POCName: this.model.contractPocName,
			POCEmail: this.model.contractPocEmail,
			POCPhone: this.model.contractPocPhone,
			address: this.model.contractAddress,
			city: this.model.contractCity,
			state: this.model.contractState,
			zip: this.model.contractZip,
			paymentMethod: this.model.contractPaymentMethod,
			surchargeBillingEvents,
		}, this.branchId, this.loggedInUser)
			.then((data) => {
				this.loading = false
				window.history.go(-1)
			})
			.catch((err) => {
				if (err && err.data && err.data.errors) {
					err.data.errors.map((e) => {
						this.errorMessage += e.message + '<br/>'
					})
				}
				else {
					this.errorMessage += err.data.message + '<br/>'
				}
			})
			.finally(() => {
				this.loading = false;
			})
	}

	mappingContractDatas(contracts) {
		return contracts.map((contract) => {
			return {
				value: contract.id,
				title: contract.id,
				names: contract.contractName,
				Key: contract.id + ' | ' + contract.contractName,
				Value: contract.id
			};
		})
	}

	loadContractData(searchKey, offset) {
		let loadDatas = null;
		if (searchKey) {
			const searchObj = {
				queryText: '%' + searchKey + '%',
				isQuery: false
			}
			loadDatas = searchObj;
		}

		this.ContractService.all(loadDatas, offset, AppConstants.defaultPageLimit)
			.then((data) => {
				if (offset === 0 || offset == undefined) {
					this.contracts = this.mappingContractDatas(data.results);
					this.totalContract = data.total;
				} else {
					const contracts = this.mappingContractDatas(data.results);
					this.contracts = this.contracts.concat(contracts);
					this.totalContract = data.total;
				}
			})
			.catch((err) => {
				console.log(err);
			})
	}

	resetBillingCategory(type) {
		if (!this.model[`billToContract${type}status`]) this.model[`billToContract${type}Id`] = null;
	}

	sameForAll(value) {
		if (this.model.sameForAll) {
			Object.values(this.contractIdKeyObj).forEach(key => {
				this.model[`billToContract${key}Id`] = value;
			})
		}
	}

	getBillingRulesInfo(type) {
		const contractId = this.model[`billToContract${type}Id`];
		const contractInfo = [];

		if (!contractId) return;

		if (this.model.sameForAll) {
			Object.values(this.contractIdKeyObj).forEach(key => {
				this.billingCategoryObj[`billToContract${key}Id`] = { process: true };
				contractInfo.push({
					type: key,
					contractId: contractId.value
				})
			})
		}
		else {
			this.billingCategoryObj[`billToContract${type}Id`] = { process: true };
			contractInfo.push({
				type,
				contractId: contractId.value
			})
		}

		this.Service.getBillingRulesInfo(this.languageId, contractInfo)
			.then((data) => {
				if (this.model.sameForAll) {
					Object.values(this.contractIdKeyObj).forEach(key => {
						this.billingCategoryObj[`billToContract${key}Id`].details = data[type];
					})
				}
				else this.billingCategoryObj[`billToContract${type}Id`].details = data[type];
			})
			.catch((err) => {
				console.log(err);
			})
			.finally(() => {
				if (this.model.sameForAll) {
					Object.values(this.contractIdKeyObj).forEach(key => {
						this.billingCategoryObj[`billToContract${key}Id`].process = false;
					})
				}
				else this.billingCategoryObj[`billToContract${type}Id`].process = false;
			})
	}

	uploadContractDocuments(stat) {
		this.Modal.uploadContractDocuments(stat, [], ({ modal, data, $scope}) => {
			this.CustomerService.uploadContractDocument(data, this.rawId, this.branchId)
				.then((data) => { 
					this.model.totalContractDocuments = data.totalFiles;
				})
				.catch((err) => {
					if (err && err.data && err.data.message) {
						this.Modal.errorModal(err.data.message);
					}
				})
				.finally(() => {
					$scope.model.loading = false;
					modal.close();
				})
		}, ({ modal }) => {
			if (modal) modal.close();
		})
	}

	openSurchargeHistory() {
		if (this.surchargeHistoryLoading) return;
		this.surchargeHistoryLoading = true;

		this.Service.getSurchargeHistory(this.rawId)
			.then((rows) => {
				const eventLabels = {};
				(this.model.surcharges[this.surchargeTypeList[0]].billingEventOptions || []).forEach((option) => {
					eventLabels[option.id] = option.label;
				});
				this.Modal.surchargeHistory({
					customerName: this.model.name,
					rows,
					labelKeys: this.surchargeLabelKeys,
					eventLabels
				});
			})
			.catch((err) => {
				if (err && err.data && err.data.message) {
					this.Modal.errorModal(err.data.message);
				}
			})
			.finally(() => {
				this.surchargeHistoryLoading = false;
			});
	}

	viewContractDocuments() {
		this.Modal.viewContractDocuments(this.rawId, ({ modal, data }) => {
			this.model.totalContractDocuments = data.length;
		}, ({ modal, data }) => {
			if (data) {
				this.model.totalContractDocuments = data.length;
			}
			if (modal) modal.close();
		})
	}

	ngPercentage() {
		if (this.model.annualIncrease && !this.model.annualIncrease.endsWith('%')) {
			return this.model.annualIncrease = this.model.annualIncrease + '%';
		}
	}

	removePrecentageSign() {
		if (this.model.annualIncrease && this.model.annualIncrease.endsWith('%')) {
			return this.model.annualIncrease = this.model.annualIncrease.replace('%', '');
		}
	}

	convertStr(str) {
		if (!str) return;
		return Number(str.replace('%', ''));
	}

	getContractType(searchKey, offset) {
        searchKey = searchKey || '';

		const obj = {
			queryJSON: {
				rules: [
					{
						group: {
							rules: [
								{
									field: "id",
									condition: "like",
									data: "%" + searchKey + "%"
								},
								{
									field: "type",
									condition: "like",
									data: "%" + searchKey + "%"
								}
							],
							operator: "OR"
						}
					}
				],
				operator: "AND"
			}
		}

        this.model.contractTypeObj.loading = true;
        this.ContractTypeService.all(obj, offset, AppConstants.defaultPageLimit)
            .then((data) => {
                if (offset === 0 || offset == undefined) {
                    this.model.contractTypeObj.totalRecords = data.total;
                    this.model.contractTypeObj.results = this.contractTypeMap(data.results);
                }
                else {
                    const results = this.contractTypeMap(data.results);
                    this.model.contractTypeObj.results = this.model.contractTypeObj.results.concat(results);
                }
            })
            .catch((err) => {
                this.Modal.errorModal(err.data.message);
            })
            .finally(() => {
                this.model.contractTypeObj.loading = false;
            })
    }

    contractTypeMap(events) {
        return events.map((data) => {
            return {
                Key: data.type,
                Value: data.id
            }
        });
    }

	handleCustomerContractData(contractType) {
		if (contractType && contractType.Value) {
			this.Service.getCustomerContractData(contractType.Value, this.rawId)
				.then((data) => {
					if (data && data.length > 0) {
						this.model.contractPocName = data[0].POCName;
						this.model.contractPocEmail = data[0].POCEmail;
						this.model.contractPocPhone = data[0].POCPhone;
						this.model.contractAddress = data[0].address;
						this.model.contractCity = data[0].city;
						this.model.contractState = data[0].state;
						this.model.contractZip = data[0].zip;
						this.model.contractPaymentMethod = data[0].paymentMethod;
					}
					else this.setCustomerContractDataNull();

				})
				.catch((err) => {
					console.log("err", err)
				})
		}
		else this.setCustomerContractDataNull()
	}

	setCustomerContractDataNull() {
		this.model.contractPocName = null;
		this.model.contractPocEmail = null;
		this.model.contractPocPhone = null;
		this.model.contractAddress = null;
		this.model.contractCity = null;
		this.model.contractState = null;
		this.model.contractZip = null;
		this.model.contractPaymentMethod = null;
	}
}

export default CustomerEditController;



// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/customer/edit/customer.edit.controller.js